// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"97fa34cf","778":"d5aa5694"}[chunkId] + ".chunk.css";
};